import React, {useState} from "react";
import TermsConditions from "./index";

interface Props {
    identification?: string;
    className?: string;
    setOpenComponent?: React.Dispatch<React.SetStateAction<boolean>>;
    setValue?: React.Dispatch<React.SetStateAction<number>>;
}
export default function IdentificationConsult({identification, className, setOpenComponent, setValue}: Props) {
    const [open, setOpen] = useState(false)

    return(
        <>
            {open && <TermsConditions {...{identification, open, setOpen, setOpenComponent, setValue}}/>}
            <div className={`${className} cursor-pointer w-full`} onClick={() => {
                if (identification && identification.length >= 13) {
                    if(setValue) {
                        setValue(0)
                    }
                }
                // Validación -> se debe permitir visualizar únicamente si no es menos de edad
                // Las personas menores de edad no pueden visualizar los términos y condiciones
                // Siempre contiene los caracteres ***
                if (!identification?.includes('***')) {
                    setOpen(true)
                }
            }}>{identification}</div>
        </>
    )

}
